<ng-template [ngIf]="!showLayout" [ngIfElse]="layout">
  <router-outlet></router-outlet>
</ng-template>

<ng-template #layout>
  <app-navigation>
    <router-outlet></router-outlet>
  </app-navigation>
</ng-template>